@media (width >= 768px) {
  .doubleSlider_fieldset {
    flex-direction: column;
  }
}

.doubleSlider_legend__isHidden:not(:focus, :active) {
  clip-path: inset(50%);
  height: 1px;
  overflow: hidden;
  opacity: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
}

.doubleSlider_helperText {
  order: 3;
}

@media (width <= 768px) {
  .doubleSlider_helperText__labelHidden {
    margin-top: 16px;
  }
}

.doubleSlider_sliders__disabled {
  opacity: var(--opacity-disabled-numberfield-input);
}
